import { loadStripe, type Stripe } from "@stripe/stripe-js";
import { supabase } from "@/integrations/supabase/client";

let stripePromise: Promise<Stripe | null> | null = null;

export const getStripe = async (): Promise<Stripe | null> => {
  if (stripePromise) return stripePromise;
  const { data, error } = await supabase.functions.invoke("stripe-config");
  if (error || !data?.publishableKey) throw new Error("Could not load Stripe");
  stripePromise = loadStripe(data.publishableKey);
  return stripePromise;
};
